import React, { FC } from 'react';
import { Button } from '@design-system/button';
import { HeadingBlock } from '@design-system/heading-block';
import { Typography } from '@design-system/typography';
import { useModal } from '~/context/ModalContext/ModalContext';

import { EventModalProps } from './models';
import './ModalContent.scss';

const EventModal: FC<EventModalProps> = ({
  onSubmit,
  heading,
  content,
  cancelBtn,
  confirmBtn,
}) => {
  const { closeModal } = useModal();

  return (
    <div className="event-modal">
      {heading ? (
        <HeadingBlock
          className="event-modal__heading"
          align="center"
          headline={heading}
          headlineTag="h3"
        />
      ) : null}

      <Typography
        className="event-modal__content"
        variant="body"
        size="m"
        content={content}
      />

      <div className="event-modal__cta-wrapper">
        <Button
          onClick={() => {
            onSubmit();
            closeModal();
          }}
          {...confirmBtn}
          className='event-modal__cta--approve'
        >
          {confirmBtn.text}
        </Button>

        <Button onClick={closeModal} {...cancelBtn} className='event-modal__cta--cancel'>
          {cancelBtn.text}
        </Button>
      </div>
    </div>
  );
};

export default EventModal;
